// extracted by mini-css-extract-plugin
export var addToCartButton = "_tc-b";
export var arrowButtonContainer = "_tc-9";
export var arrowButtonIcon = "_tc-a";
export var carouselArrowButton = "_tc-6";
export var carouselElementContainer = "_tc-1";
export var galleryThumbnail = "_tc-d";
export var galleryThumbnailImage = "_tc-e";
export var left = "_tc-7";
export var productDisplayCarouselContainer = "_tc-0";
export var productTileContainer = "_tc-2";
export var productTileImage = "_tc-4";
export var productTileImageContainer = "_tc-3";
export var productTileTitle = "_tc-5";
export var right = "_tc-8";
export var sliderOverflow = "_tc-c";